<template>
    <div>
        <el-table
            :data="table"
            style="width: 100%"
            :header-cell-style="{background:'rgba(250,250,252,1)'}"
            tooltip-effect="light"
        >
            <el-table-column
                v-for="(item,index) in column"
                :key="index"
                :prop="item.prop"
                :label="item.label"
            >
                <template slot-scope="scope">
                    <template v-if="!scope.row[item.prop]">
                        <div>-</div>
                    </template>
                    <template v-if="scope.row[item.prop].length < 25">
                        <div>{{scope.row[item.prop]}}</div>
                    </template>
                    <template v-else>
                        <el-popover
                            placement="right"
                            trigger="hover"
                            popper-class="popover-max-width"
                        >
                            <div class="area-popover">{{scope.row[item.prop]}}</div>
                            <span
                                slot="reference"
                            >{{ `${scope.row[item.prop] && scope.row[item.prop].slice(0, 25)}...`}}</span>
                        </el-popover>
                    </template>
                </template>
            </el-table-column>
            <el-table-column label="查看详情" align="center">
                <template slot-scope="scope">
                    <div class="detail-button-box">
                        <el-button
                            @click.native.prevent="tableRowClick(scope)"
                            type="text"
                            size="medium"
                        >点击查看</el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <p class="table-commons">注：以上均为单项产品或服务（部分由辖内外资银行联动母行或境外分行提供）信息，鉴于跨境金融服务通常需要根据企业的需求定制综合化金融服务方案，详情敬请咨询相应机构</p>
        <div class="page">
            <p>
                共
                <span style="margin:0 8px;">{{page.total}}</span>条记录
            </p>
            <p>每页</p>
            <el-select
                size="mini"
                class="page-select"
                v-model="value"
                placeholder="页码"
                @change="onPageSizeChange"
            >
                <el-option
                    v-for="item in [{label:5,value:5},{label:10,value:10},{label:15,value:15}]"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                ></el-option>
            </el-select>
            <p>条记录</p>
            <el-pagination
                background
                layout="prev, pager, next"
                :total="page.total"
                :current-page="page.pageNo"
                :page-size="page.pageSize"
                @current-change="onPageChange"
            ></el-pagination>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    table: {
      type: Array,
      default: () => []
    },
    page: {
      type: Object,
      default: () => {
        return {
          pageNo: 1,
          pageSize: 10,
          total: 0
        }
      }
    }
  },
  data () {
    return {
      value: 10,
      column: [
        {
          label: '银行名称',
          prop: 'organizationName'
        },
        {
          label: '产品/服务',
          prop: 'name'
        },
        {
          label: '适用客户',
          prop: 'applicableCustomer',
          render: 'render'
        },
        {
          label: '机构电话',
          prop: 'orgNumbers'
        }
      ]
    }
  },
  methods: {
    onPageSizeChange (val) {
      this.value = val
      this.$emit('pageSizeChange', val)
    },
    onPageChange (page) {
      this.$emit('pageChange', page)
    },
    tableRowClick (row) {
      this.$router.push(`/table/${row.row.id}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.table-commons {
    font-size: 14px;
    font-weight: 400;
    color: rgba(193, 70, 58, 1);
    line-height: 20px;
    text-align: left;
    margin-top: 19px;
}
.page {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 31px;
    align-items: center;
    p {
        font-size: 12px;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        line-height: 21px;
        margin-right: 10px;
    }
    .page-select {
        width: 60px;
        margin-right: 10px;
    }
}
.detail-button-box {
    button {
        font-size: 14px;
        color: rgba(0, 82, 188, 1);
        line-height: 19px;
    }
}

/deep/ .el-table th.is-leaf {
    height: 60px;
    font-size: 16px;
    color: rgba(51, 51, 51, 1);
    line-height: 19px;
    padding-left: 20px;
}
/deep/ .el-table__body td {
    padding-left: 20px;
    font-size: 14px;
    color: rgba(51, 51, 51, 1);
    line-height: 19px;
}
/deep/ .el-input__inner {
    border-radius: 5px !important;
}
</style>

<style>
.popover-max-width {
    max-width: 500px;
}
</style>
